import type { TOptions } from 'i18next';
import { EditIcon } from 'lucide-react';
import { useInlineTranslationDialog } from './InlineTranslationProvider';
// eslint-disable-next-line no-restricted-imports
import { useTranslation } from 'react-i18next';

export const T = ({ k: key, options }: { k: string; options?: TOptions }) => {
  const { t } = useTranslation(options?.ns);
  const { editMode, openDialog } = useInlineTranslationDialog();

  const translation = t(key, options);
  if (!editMode) {
    return translation;
  }

  return (
    <span
      data-key={key}
      data-namespace={options?.ns}
      className='eye:relative eye:inline-block'
    >
      {translation}
      <span
        onClick={(e) => {
          e.stopPropagation();
          openDialog({ key, options });
        }}
        title='Edit translation'
      >
        <EditIcon
          className={
            'eye:size-12 eye:bg-black! eye:text-white! eye:absolute eye:left-[-2px] eye:top-[-2px]'
          }
          aria-hidden
        />
      </span>
    </span>
  );
};
